import React from 'react';
import './InputSearch.css';
import Search from '@material-ui/icons/Search';
import { withWidth } from '@material-ui/core';
import { css, cx } from 'emotion';

function InputSearch(props) {

    return (
        <div className={(props.width === "xs" || props.width === "sm") ? cx(css`width: 100% !important`,"input-icons") : "input-icons"}>
            <Search className="icon" />
            <input type="text"
                {...props}
                name="search"
                className="input-search"
                id="search" />
        </div>)
}
export default withWidth()(InputSearch)